// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import {
//   RiLineChartLine,
//   RiMoneyDollarCircleLine,
//   RiAlarmWarningLine,
//   RiFileList3Line,
//   RiPercentLine,
//   RiExchangeDollarLine,
//   RiRefreshLine,
//   RiCalendarLine,
//   RiCloseLine,
//   RiErrorWarningLine,
//   RiBankLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";

// const BASE_URL = `${process.env.REACT_APP_API_URL}/finance-report`;
// // Adjust this to match wherever your client (Bank) list endpoint actually lives
// const BANK_BASE_URL = `${process.env.REACT_APP_API_URL}/bank`;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const Toast = ({ message, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, []);
//   return (
//     <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium bg-red-50 border border-red-200 text-red-800">
//       <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const formatCurrency = (val) =>
//   `₹${Number(val || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

// const formatDate = (val) =>
//   val ? new Date(val).toLocaleDateString("en-IN") : "—";

// const getClientName = (client) => {
//   if (!client) return "—";
//   if (typeof client === "string") return "—";
//   return (
//     client.bankName ||
//     client.name ||
//     client.companyName ||
//     client.organisation ||
//     "—"
//   );
// };

// const StatCard = ({ label, value, tone = "blue" }) => {
//   const tones = {
//     blue: "bg-blue-50 border-blue-100 text-blue-500 [&_.val]:text-slate-800",
//     emerald:
//       "bg-emerald-50 border-emerald-100 text-emerald-500 [&_.val]:text-emerald-700",
//     red: "bg-red-50 border-red-100 text-red-400 [&_.val]:text-red-600",
//     amber:
//       "bg-amber-50 border-amber-100 text-amber-500 [&_.val]:text-amber-700",
//   };
//   return (
//     <div className={`px-4 py-3 rounded-lg border ${tones[tone]}`}>
//       <p className="text-[11px] uppercase font-semibold tracking-wide">
//         {label}
//       </p>
//       <p className="val text-base font-bold mt-0.5">{value}</p>
//     </div>
//   );
// };

// const EmptyState = ({ message }) => (
//   <div className="py-16 text-center">
//     <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mx-auto mb-3">
//       <RiFileList3Line className="w-7 h-7 text-blue-300" />
//     </div>
//     <span className="text-sm text-slate-400">{message}</span>
//   </div>
// );

// const LoadingRows = ({ label }) => (
//   <div className="py-16 flex flex-col items-center gap-3 text-blue-400">
//     <Spinner className="w-7 h-7 text-blue-500" />
//     <span className="text-sm">{label}</span>
//   </div>
// );

// const Th = ({ children, align = "left" }) => (
//   <th className={`px-4 py-3 text-${align}`}>
//     <span className="text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
//       {children}
//     </span>
//   </th>
// );

// const Td = ({ children, align = "left", className = "" }) => (
//   <td className={`px-4 py-3 text-${align} whitespace-nowrap ${className}`}>
//     {children}
//   </td>
// );

// const Table = ({ headers, children }) => (
//   <div className="overflow-x-auto border border-blue-100 rounded-xl">
//     <table className="w-full text-sm">
//       <thead>
//         <tr className="bg-blue-50/50 border-b border-blue-100">
//           {headers.map((h) => (
//             <Th key={h.label || h} align={h.align}>
//               {h.label || h}
//             </Th>
//           ))}
//         </tr>
//       </thead>
//       <tbody>{children}</tbody>
//     </table>
//   </div>
// );

// const TABS = [
//   { key: "profit", label: "Profit Report", icon: RiLineChartLine },
//   { key: "income", label: "Income Report", icon: RiMoneyDollarCircleLine },
//   {
//     key: "outstanding",
//     label: "Outstanding Receivables",
//     icon: RiAlarmWarningLine,
//   },
//   { key: "ledger", label: "Client Ledger", icon: RiFileList3Line },
//   { key: "gst", label: "GST Report", icon: RiPercentLine },
//   { key: "collection", label: "Collection Report", icon: RiExchangeDollarLine },
// ];

// export default function FinanceReports() {
//   const [activeTab, setActiveTab] = useState("profit");
//   const [loading, setLoading] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [reportData, setReportData] = useState(null);

//   // Global-ish filters (not all tabs use all of these)
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [profitGroupBy, setProfitGroupBy] = useState("invoice"); // invoice | month | client
//   const [gstGroupBy, setGstGroupBy] = useState("month"); // month | invoice
//   const [clientId, setClientId] = useState("");
//   const [clients, setClients] = useState([]);

//   const notify = (message) => setToast({ message });

//   const fetchClients = async () => {
//     try {
//       const res = await axios.get(`${BANK_BASE_URL}/get-banks`);
//       setClients(res.data?.data || res.data || []);
//     } catch {
//       // Non-fatal: outstanding/ledger tabs fall back to manual client id entry
//     }
//   };

//   useEffect(() => {
//     fetchClients();
//   }, []);

//   const fetchReport = useCallback(async () => {
//     setLoading(true);
//     setReportData(null);
//     try {
//       const params = {};
//       if (startDate) params.startDate = startDate;
//       if (endDate) params.endDate = endDate;

//       let endpoint = activeTab;
//       if (activeTab === "outstanding") endpoint = "outstanding-receivables";
//       if (activeTab === "ledger") endpoint = "client-ledger";

//       if (activeTab === "profit") params.groupBy = profitGroupBy;
//       if (activeTab === "gst") params.groupBy = gstGroupBy;

//       if (activeTab === "ledger") {
//         if (!clientId) {
//           setLoading(false);
//           return;
//         }
//         params.clientId = clientId;
//       } else if (clientId) {
//         params.clientId = clientId; // profit, income, outstanding, gst, collection
//       }

//       const res = await axios.get(`${BASE_URL}/${endpoint}`, { params });
//       setReportData(res.data);
//     } catch (err) {
//       notify(err?.response?.data?.message || "Failed to load report");
//     } finally {
//       setLoading(false);
//     }
//   }, [activeTab, startDate, endDate, profitGroupBy, gstGroupBy, clientId]);

//   useEffect(() => {
//     fetchReport();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [activeTab]);

//   const clearFilters = () => {
//     setStartDate("");
//     setEndDate("");
//     setClientId("");
//     setProfitGroupBy("invoice");
//     setGstGroupBy("month");
//   };

//   /* ---------------------------------------------------------------- */
//   /*  Tab-specific renderers                                            */
//   /* ---------------------------------------------------------------- */

//   const renderProfit = () => {
//     if (!reportData) return null;
//     const { summary, data } = reportData;
//     const rows = data || [];
//     const isGrouped = profitGroupBy !== "invoice";
//     const keyLabel =
//       profitGroupBy === "month"
//         ? "Month"
//         : profitGroupBy === "client"
//           ? "Client"
//           : null;

//     return (
//       <>
//         <div className="grid grid-cols-4 gap-3 mb-5">
//           <StatCard
//             label="Total Invoice Amount"
//             value={formatCurrency(summary?.totalInvoiceAmount)}
//           />
//           <StatCard
//             label="Total RO Net Payable"
//             value={formatCurrency(summary?.totalNetPayable)}
//             tone="amber"
//           />
//           <StatCard
//             label="Total Profit"
//             value={formatCurrency(summary?.totalProfit)}
//             tone="emerald"
//           />
//           <StatCard
//             label="Overall Margin"
//             value={`${summary?.overallMarginPercent ?? 0}%`}
//             tone="blue"
//           />
//         </div>
//         {rows.length === 0 ? (
//           <EmptyState message="No invoices found for this period." />
//         ) : isGrouped ? (
//           <Table
//             headers={[
//               keyLabel,
//               "Invoices",
//               "Invoice Amount",
//               "RO Net Payable",
//               "Profit",
//               "Margin",
//             ]}
//           >
//             {rows.map((r, i) => (
//               <tr
//                 key={i}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">
//                   {r[profitGroupBy]}
//                 </Td>
//                 <Td>{r.invoiceCount}</Td>
//                 <Td>{formatCurrency(r.invoiceTotal)}</Td>
//                 <Td className="text-amber-600">
//                   {formatCurrency(r.releaseOrderNetPayable)}
//                 </Td>
//                 <Td className="text-emerald-600 font-medium">
//                   {formatCurrency(r.profit)}
//                 </Td>
//                 <Td>{r.marginPercent}%</Td>
//               </tr>
//             ))}
//           </Table>
//         ) : (
//           <Table
//             headers={[
//               "Invoice No.",
//               "Date",
//               "Client",
//               "RO No.",
//               "Invoice Amount",
//               "RO Net Payable",
//               "Profit",
//               "Margin",
//             ]}
//           >
//             {rows.map((r) => (
//               <tr
//                 key={r.invoiceId}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">
//                   {r.invoiceNumber}
//                 </Td>
//                 <Td>{formatDate(r.invoiceDate)}</Td>
//                 <Td>{r.client}</Td>
//                 <Td>{r.roNumber || "—"}</Td>
//                 <Td>{formatCurrency(r.invoiceTotal)}</Td>
//                 <Td className="text-amber-600">
//                   {formatCurrency(r.releaseOrderNetPayable)}
//                 </Td>
//                 <Td className="text-emerald-600 font-medium">
//                   {formatCurrency(r.profit)}
//                 </Td>
//                 <Td>{r.marginPercent}%</Td>
//               </tr>
//             ))}
//           </Table>
//         )}
//       </>
//     );
//   };

//   const renderIncome = () => {
//     if (!reportData) return null;
//     const { summary, data } = reportData;
//     const rows = data || [];
//     return (
//       <>
//         <div className="grid grid-cols-5 gap-3 mb-5">
//           <StatCard
//             label="Revenue"
//             value={formatCurrency(summary?.totalRevenue)}
//           />
//           <StatCard
//             label="Cost (RO Payable)"
//             value={formatCurrency(summary?.totalCost)}
//             tone="amber"
//           />
//           <StatCard
//             label="Gross Profit"
//             value={formatCurrency(summary?.totalGrossProfit)}
//             tone="emerald"
//           />
//           <StatCard
//             label="Collected"
//             value={formatCurrency(summary?.totalCollected)}
//             tone="blue"
//           />
//           <StatCard
//             label="GST Collected"
//             value={formatCurrency(summary?.totalGST)}
//             tone="amber"
//           />
//         </div>
//         {rows.length === 0 ? (
//           <EmptyState message="No income data found for this period." />
//         ) : (
//           <Table
//             headers={[
//               "Month",
//               "Invoices",
//               "Revenue",
//               "Cost",
//               "Gross Profit",
//               "Margin",
//               "Collected",
//             ]}
//           >
//             {rows.map((r) => (
//               <tr
//                 key={r.month}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">{r.month}</Td>
//                 <Td>{r.invoiceCount}</Td>
//                 <Td>{formatCurrency(r.revenue)}</Td>
//                 <Td className="text-amber-600">{formatCurrency(r.cost)}</Td>
//                 <Td className="text-emerald-600 font-medium">
//                   {formatCurrency(r.grossProfit)}
//                 </Td>
//                 <Td>{r.grossMarginPercent}%</Td>
//                 <Td className="text-blue-600">
//                   {formatCurrency(r.collectedAmount)}
//                 </Td>
//               </tr>
//             ))}
//           </Table>
//         )}
//       </>
//     );
//   };

//   const renderOutstanding = () => {
//     if (!reportData) return null;
//     const { grandTotal, data } = reportData;
//     const rows = data || [];
//     const buckets = ["0-30", "31-60", "61-90", "91-180", "180+"];
//     return (
//       <>
//         <div className="grid grid-cols-6 gap-3 mb-5">
//           <StatCard
//             label="Total Outstanding"
//             value={formatCurrency(grandTotal?.totalOutstanding)}
//             tone="red"
//           />
//           {buckets.map((b) => (
//             <StatCard
//               key={b}
//               label={`${b} days`}
//               value={formatCurrency(grandTotal?.buckets?.[b])}
//               tone="amber"
//             />
//           ))}
//         </div>
//         {rows.length === 0 ? (
//           <EmptyState message="No outstanding receivables found." />
//         ) : (
//           <Table
//             headers={[
//               "Client",
//               "Total Outstanding",
//               "0-30",
//               "31-60",
//               "61-90",
//               "91-180",
//               "180+",
//             ]}
//           >
//             {rows.map((r) => (
//               <tr
//                 key={r.clientId}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">{r.clientName}</Td>
//                 <Td className="text-red-500 font-medium">
//                   {formatCurrency(r.totalOutstanding)}
//                 </Td>
//                 {buckets.map((b) => (
//                   <Td key={b}>{formatCurrency(r.buckets?.[b])}</Td>
//                 ))}
//               </tr>
//             ))}
//           </Table>
//         )}
//       </>
//     );
//   };

//   const renderLedger = () => {
//     if (!clientId) {
//       return (
//         <EmptyState message="Select a client above to view their ledger." />
//       );
//     }
//     if (!reportData) return null;
//     const { openingBalance, closingBalance, totals, ledger } = reportData;
//     const rows = ledger || [];
//     return (
//       <>
//         <div className="grid grid-cols-4 gap-3 mb-5">
//           <StatCard
//             label="Opening Balance"
//             value={formatCurrency(openingBalance)}
//           />
//           <StatCard
//             label="Bills Raised"
//             value={formatCurrency(totals?.totalBillsRaised)}
//             tone="amber"
//           />
//           <StatCard
//             label="Payments & Credits"
//             value={formatCurrency(totals?.totalPaymentsAndCreditsReceived)}
//             tone="emerald"
//           />
//           <StatCard
//             label="Closing Balance"
//             value={formatCurrency(closingBalance)}
//             tone="blue"
//           />
//         </div>
//         {rows.length === 0 ? (
//           <EmptyState message="No transactions found for this client in this period." />
//         ) : (
//           <Table
//             headers={[
//               "Date",
//               "Type",
//               "Reference",
//               "Description",
//               "Debit",
//               "Credit",
//               "Balance",
//             ]}
//           >
//             {rows.map((t, i) => (
//               <tr
//                 key={i}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td>{formatDate(t.date)}</Td>
//                 <Td className="capitalize">{t.type.replace("_", " ")}</Td>
//                 <Td>{t.reference || "—"}</Td>
//                 <Td className="whitespace-normal max-w-xs text-slate-600">
//                   {t.description}
//                 </Td>
//                 <Td
//                   className={
//                     t.debit ? "text-red-500 font-medium" : "text-slate-300"
//                   }
//                 >
//                   {t.debit ? formatCurrency(t.debit) : "—"}
//                 </Td>
//                 <Td
//                   className={
//                     t.credit ? "text-emerald-600 font-medium" : "text-slate-300"
//                   }
//                 >
//                   {t.credit ? formatCurrency(t.credit) : "—"}
//                 </Td>
//                 <Td className="font-semibold text-slate-800">
//                   {formatCurrency(t.balance)}
//                 </Td>
//               </tr>
//             ))}
//           </Table>
//         )}
//       </>
//     );
//   };

//   const renderGST = () => {
//     if (!reportData) return null;
//     const { summary, data } = reportData;
//     const rows = data || [];
//     const isInvoiceWise = gstGroupBy === "invoice";
//     return (
//       <>
//         <div className="grid grid-cols-5 gap-3 mb-5">
//           <StatCard
//             label="Taxable Value"
//             value={formatCurrency(summary?.totalTaxableValue)}
//           />
//           <StatCard
//             label="CGST"
//             value={formatCurrency(summary?.totalCGST)}
//             tone="amber"
//           />
//           <StatCard
//             label="SGST"
//             value={formatCurrency(summary?.totalSGST)}
//             tone="amber"
//           />
//           <StatCard
//             label="Total Tax"
//             value={formatCurrency(summary?.totalTax)}
//             tone="emerald"
//           />
//           <StatCard
//             label="Invoice Value"
//             value={formatCurrency(summary?.totalInvoiceValue)}
//             tone="blue"
//           />
//         </div>
//         {rows.length === 0 ? (
//           <EmptyState message="No GST data found for this period." />
//         ) : isInvoiceWise ? (
//           <Table
//             headers={[
//               "Invoice No.",
//               "Date",
//               "GSTIN",
//               "Taxable Value",
//               "CGST",
//               "SGST",
//               "Total Tax",
//               "Invoice Value",
//             ]}
//           >
//             {rows.map((r) => (
//               <tr
//                 key={r.invoiceId}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">
//                   {r.invoiceNumber}
//                 </Td>
//                 <Td>{formatDate(r.invoiceDate)}</Td>
//                 <Td>{r.clientGSTNumber || "—"}</Td>
//                 <Td>{formatCurrency(r.taxableValue)}</Td>
//                 <Td className="text-amber-600">
//                   {formatCurrency(r.cgstAmount)}
//                 </Td>
//                 <Td className="text-amber-600">
//                   {formatCurrency(r.sgstAmount)}
//                 </Td>
//                 <Td className="text-emerald-600 font-medium">
//                   {formatCurrency(r.totalTax)}
//                 </Td>
//                 <Td>{formatCurrency(r.invoiceValue)}</Td>
//               </tr>
//             ))}
//           </Table>
//         ) : (
//           <Table
//             headers={[
//               "Month",
//               "Invoices",
//               "Taxable Value",
//               "CGST",
//               "SGST",
//               "Total Tax",
//               "Invoice Value",
//             ]}
//           >
//             {rows.map((r) => (
//               <tr
//                 key={r.month}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">{r.month}</Td>
//                 <Td>{r.invoiceCount}</Td>
//                 <Td>{formatCurrency(r.taxableValue)}</Td>
//                 <Td className="text-amber-600">
//                   {formatCurrency(r.cgstAmount)}
//                 </Td>
//                 <Td className="text-amber-600">
//                   {formatCurrency(r.sgstAmount)}
//                 </Td>
//                 <Td className="text-emerald-600 font-medium">
//                   {formatCurrency(r.totalTax)}
//                 </Td>
//                 <Td>{formatCurrency(r.invoiceValue)}</Td>
//               </tr>
//             ))}
//           </Table>
//         )}
//       </>
//     );
//   };

//   const renderCollection = () => {
//     if (!reportData) return null;
//     const { summary, data } = reportData;
//     const rows = data || [];
//     return (
//       <>
//         <div className="grid grid-cols-4 gap-3 mb-5">
//           <StatCard
//             label="Total Billed"
//             value={formatCurrency(summary?.totalBilled)}
//           />
//           <StatCard
//             label="Total Collected"
//             value={formatCurrency(summary?.totalCollected)}
//             tone="emerald"
//           />
//           <StatCard
//             label="Total Pending"
//             value={formatCurrency(summary?.totalPending)}
//             tone="red"
//           />
//           <StatCard
//             label="Collection Efficiency"
//             value={`${summary?.collectionEfficiencyPercent ?? 0}%`}
//             tone="blue"
//           />
//         </div>
//         {rows.length === 0 ? (
//           <EmptyState message="No collection data found for this period." />
//         ) : (
//           <Table
//             headers={[
//               "Month",
//               "Billed",
//               "Collected",
//               "Pending",
//               "Cumulative Pending",
//             ]}
//           >
//             {rows.map((r) => (
//               <tr
//                 key={r.month}
//                 className="border-b border-blue-50 hover:bg-blue-50/40 transition"
//               >
//                 <Td className="font-semibold text-slate-800">{r.month}</Td>
//                 <Td>{formatCurrency(r.billedAmount)}</Td>
//                 <Td className="text-emerald-600 font-medium">
//                   {formatCurrency(r.collectedAmount)}
//                 </Td>
//                 <Td className="text-red-500">
//                   {formatCurrency(r.pendingAmount)}
//                 </Td>
//                 <Td>{formatCurrency(r.cumulativePending)}</Td>
//               </tr>
//             ))}
//           </Table>
//         )}
//       </>
//     );
//   };

//   const renderActiveTab = () => {
//     if (loading) return <LoadingRows label="Crunching the numbers…" />;
//     switch (activeTab) {
//       case "profit":
//         return renderProfit();
//       case "income":
//         return renderIncome();
//       case "outstanding":
//         return renderOutstanding();
//       case "ledger":
//         return renderLedger();
//       case "gst":
//         return renderGST();
//       case "collection":
//         return renderCollection();
//       default:
//         return null;
//     }
//   };

//   const showClientFilter = true;
//   const showDateFilter = activeTab !== "outstanding";

//   return (
//     <div className="min-h-screen bg-white text-slate-800">
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
//               <RiLineChartLine className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-blue-800 tracking-tight">
//                 Finance Reports
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 Profit · Income · Receivables · GST
//               </p>
//             </div>
//           </div>
//           <button
//             onClick={fetchReport}
//             disabled={loading || (activeTab === "ledger" && !clientId)}
//             title="Refresh"
//             className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
//           >
//             <RiRefreshLine
//               className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
//             />
//           </button>
//         </div>

//         {/* Tab strip */}
//         <div className="w-full mx-auto px-6 flex gap-1 overflow-x-auto pb-2 pt-1">
//           {TABS.map((tab) => {
//             const Icon = tab.icon;
//             const active = activeTab === tab.key;
//             return (
//               <button
//                 key={tab.key}
//                 onClick={() => setActiveTab(tab.key)}
//                 className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition ${
//                   active
//                     ? "bg-blue-600 text-white shadow-md shadow-blue-200"
//                     : "text-blue-500 hover:bg-blue-50 border border-transparent"
//                 }`}
//               >
//                 <Icon className="w-4 h-4" />
//                 {tab.label}
//               </button>
//             );
//           })}
//         </div>
//       </header>

//       <div className="w-full mx-auto px-6 pt-6 pb-10">
//         {/* Filter bar */}
//         <div className="bg-white border border-blue-100 rounded-2xl p-4 mb-5 shadow-sm flex items-end gap-4 flex-wrap">
//           {showDateFilter && (
//             <>
//               <div className="flex flex-col gap-1.5">
//                 <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                   From
//                 </label>
//                 <div className="relative">
//                   <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//                   <input
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//                   />
//                 </div>
//               </div>
//               <div className="flex flex-col gap-1.5">
//                 <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                   To
//                 </label>
//                 <div className="relative">
//                   <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//                   <input
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//                   />
//                 </div>
//               </div>
//             </>
//           )}

//           {showClientFilter && (
//             <div className="flex flex-col gap-1.5">
//               <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Client{" "}
//                 {activeTab === "ledger" && (
//                   <span className="text-red-400">*</span>
//                 )}
//               </label>
//               <div className="relative">
//                 <RiBankLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
//                 {clients.length > 0 ? (
//                   <select
//                     value={clientId}
//                     onChange={(e) => setClientId(e.target.value)}
//                     className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none min-w-[200px]"
//                   >
//                     <option value="">
//                       {activeTab === "ledger"
//                         ? "Select a client"
//                         : "All clients"}
//                     </option>
//                     {clients.map((c) => (
//                       <option key={c._id} value={c._id}>
//                         {getClientName(c)}
//                       </option>
//                     ))}
//                   </select>
//                 ) : (
//                   <input
//                     value={clientId}
//                     onChange={(e) => setClientId(e.target.value)}
//                     placeholder="Client ID"
//                     className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition min-w-[200px]"
//                   />
//                 )}
//               </div>
//             </div>
//           )}

//           {activeTab === "profit" && (
//             <div className="flex flex-col gap-1.5">
//               <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Group By
//               </label>
//               <select
//                 value={profitGroupBy}
//                 onChange={(e) => setProfitGroupBy(e.target.value)}
//                 className="bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none"
//               >
//                 <option value="invoice">Invoice</option>
//                 <option value="month">Month</option>
//                 <option value="client">Client</option>
//               </select>
//             </div>
//           )}

//           {activeTab === "gst" && (
//             <div className="flex flex-col gap-1.5">
//               <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Group By
//               </label>
//               <select
//                 value={gstGroupBy}
//                 onChange={(e) => setGstGroupBy(e.target.value)}
//                 className="bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none"
//               >
//                 <option value="month">Month</option>
//                 <option value="invoice">Invoice</option>
//               </select>
//             </div>
//           )}

//           <div className="flex gap-2 ml-auto">
//             <button
//               onClick={clearFilters}
//               className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//             >
//               <RiCloseLine className="w-4 h-4" /> Clear
//             </button>
//             <button
//               onClick={fetchReport}
//               disabled={activeTab === "ledger" && !clientId}
//               className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-50"
//             >
//               Apply
//             </button>
//           </div>
//         </div>

//         {/* Report body */}
//         <div className="bg-white border border-blue-100 rounded-2xl p-5 shadow-sm">
//           {renderActiveTab()}
//         </div>
//       </div>

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  RiLineChartLine,
  RiMoneyDollarCircleLine,
  RiAlarmWarningLine,
  RiFileList3Line,
  RiPercentLine,
  RiExchangeDollarLine,
  RiRefreshLine,
  RiCalendarLine,
  RiCloseLine,
  RiErrorWarningLine,
  RiBankLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const BASE_URL = `${process.env.REACT_APP_API_URL}/finance-report`;
// Adjust this to match wherever your client (Bank) list endpoint actually lives
const BANK_BASE_URL = `${process.env.REACT_APP_API_URL}/bank`;

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium bg-red-50 border border-red-200 text-red-800">
      <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const formatCurrency = (val) =>
  `₹${Number(val || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

const formatDate = (val) =>
  val ? new Date(val).toLocaleDateString("en-IN") : "—";

const getClientName = (client) => {
  if (!client) return "—";
  if (typeof client === "string") return "—";
  return (
    client.bankName ||
    client.name ||
    client.companyName ||
    client.organisation ||
    "—"
  );
};

const StatCard = ({ label, value, tone = "blue" }) => {
  const tones = {
    blue: "bg-blue-50 border-blue-100 text-blue-500 [&_.val]:text-slate-800",
    emerald:
      "bg-emerald-50 border-emerald-100 text-emerald-500 [&_.val]:text-emerald-700",
    red: "bg-red-50 border-red-100 text-red-400 [&_.val]:text-red-600",
    amber:
      "bg-amber-50 border-amber-100 text-amber-500 [&_.val]:text-amber-700",
  };
  return (
    <div className={`px-4 py-3 rounded-lg border ${tones[tone]}`}>
      <p className="text-[11px] uppercase font-semibold tracking-wide">
        {label}
      </p>
      <p className="val text-base font-bold mt-0.5">{value}</p>
    </div>
  );
};

const EmptyState = ({ message }) => (
  <div className="py-16 text-center">
    <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center mx-auto mb-3">
      <RiFileList3Line className="w-7 h-7 text-blue-300" />
    </div>
    <span className="text-sm text-slate-400">{message}</span>
  </div>
);

const LoadingRows = ({ label }) => (
  <div className="py-16 flex flex-col items-center gap-3 text-blue-400">
    <Spinner className="w-7 h-7 text-blue-500" />
    <span className="text-sm">{label}</span>
  </div>
);

const Th = ({ children, align = "left" }) => (
  <th className={`px-4 py-3 text-${align}`}>
    <span className="text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
      {children}
    </span>
  </th>
);

const Td = ({ children, align = "left", className = "" }) => (
  <td className={`px-4 py-3 text-${align} whitespace-nowrap ${className}`}>
    {children}
  </td>
);

const Table = ({ headers, children }) => (
  <div className="overflow-x-auto border border-blue-100 rounded-xl">
    <table className="w-full text-sm">
      <thead>
        <tr className="bg-blue-50/50 border-b border-blue-100">
          {headers.map((h) => (
            <Th key={h.label || h} align={h.align}>
              {h.label || h}
            </Th>
          ))}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);

const TABS = [
  { key: "profit", label: "Profit Report", icon: RiLineChartLine },
  { key: "income", label: "Income Report", icon: RiMoneyDollarCircleLine },
  {
    key: "outstanding",
    label: "Outstanding Receivables",
    icon: RiAlarmWarningLine,
  },
  { key: "ledger", label: "Client Ledger", icon: RiFileList3Line },
  { key: "gst", label: "GST Report", icon: RiPercentLine },
  { key: "collection", label: "Collection Report", icon: RiExchangeDollarLine },
];

export default function FinanceReports() {
  const [activeTab, setActiveTab] = useState("profit");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [reportData, setReportData] = useState(null);

  // Global-ish filters (not all tabs use all of these)
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [profitGroupBy, setProfitGroupBy] = useState("invoice"); // invoice | month | client
  const [gstGroupBy, setGstGroupBy] = useState("month"); // month | invoice
  const [clientId, setClientId] = useState("");
  const [clients, setClients] = useState([]);

  const notify = (message) => setToast({ message });

  const fetchClients = async () => {
    try {
      const res = await axios.get(`${BANK_BASE_URL}/get-banks`);
      setClients(res.data?.data || res.data || []);
    } catch {
      // Non-fatal: outstanding/ledger tabs fall back to manual client id entry
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    setReportData(null);
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      let endpoint = activeTab;
      if (activeTab === "outstanding") endpoint = "outstanding-receivables";
      if (activeTab === "ledger") endpoint = "client-ledger";

      if (activeTab === "profit") params.groupBy = profitGroupBy;
      if (activeTab === "gst") params.groupBy = gstGroupBy;

      if (activeTab === "ledger") {
        if (!clientId) {
          setLoading(false);
          return;
        }
        params.clientId = clientId;
      } else if (clientId) {
        params.clientId = clientId; // profit, income, outstanding, gst, collection
      }

      const res = await axios.get(`${BASE_URL}/${endpoint}`, { params });
      setReportData(res.data);
    } catch (err) {
      notify(err?.response?.data?.message || "Failed to load report");
    } finally {
      setLoading(false);
    }
  }, [activeTab, startDate, endDate, profitGroupBy, gstGroupBy, clientId]);

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const clearFilters = () => {
    setStartDate("");
    setEndDate("");
    setClientId("");
    setProfitGroupBy("invoice");
    setGstGroupBy("month");
  };

  /* ---------------------------------------------------------------- */
  /*  Tab-specific renderers                                            */
  /* ---------------------------------------------------------------- */

  const renderProfit = () => {
    if (!reportData) return null;
    const { summary, data } = reportData;
    const rows = data || [];
    const isGrouped = profitGroupBy !== "invoice";
    const keyLabel =
      profitGroupBy === "month"
        ? "Month"
        : profitGroupBy === "client"
          ? "Client"
          : null;

    return (
      <>
        <div className="grid grid-cols-4 gap-3 mb-5">
          <StatCard
            label="Bill Sub Total (Excl. GST)"
            value={formatCurrency(summary?.totalInvoiceSubTotal)}
          />
          <StatCard
            label="Total RO Base Amount (Excl. GST)"
            value={formatCurrency(summary?.totalNetPayable)}
            tone="amber"
          />
          <StatCard
            label="Total Profit"
            value={formatCurrency(summary?.totalProfit)}
            tone="emerald"
          />
          {/* <StatCard
            label="Overall Margin"
            value={`${summary?.overallMarginPercent ?? 0}%`}
            tone="blue"
          /> */}
        </div>
        {rows.length === 0 ? (
          <EmptyState message="No invoices found for this period." />
        ) : isGrouped ? (
          <Table
            headers={[
              keyLabel,
              "Invoices",
              "Bill Sub Total (Excl. GST)",
              "RO Base Amt (Excl. GST)",
              "Profit",
              // "Margin",
            ]}
          >
            {rows.map((r, i) => (
              <tr
                key={i}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">
                  {r[profitGroupBy]}
                </Td>
                <Td>{r.invoiceCount}</Td>
                <Td>{formatCurrency(r.invoiceSubTotal)}</Td>
                <Td className="text-amber-600">
                  {formatCurrency(r.releaseOrderNetPayable)}
                </Td>
                <Td className="text-emerald-600 font-medium">
                  {formatCurrency(r.profit)}
                </Td>
                {/* <Td>{r.marginPercent}%</Td> */}
              </tr>
            ))}
          </Table>
        ) : (
          <Table
            headers={[
              "Invoice No.",
              "Date",
              "Client",
              "RO No.",
              "Bill Sub Total (Excl. GST)",
              "RO Base Amt (Excl. GST)",
              "Profit",
              // "Margin",
            ]}
          >
            {rows.map((r) => (
              <tr
                key={r.invoiceId}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">
                  {r.invoiceNumber}
                </Td>
                <Td>{formatDate(r.invoiceDate)}</Td>
                <Td>{r.client}</Td>
                <Td>{r.roNumber || "—"}</Td>
                <Td>{formatCurrency(r.invoiceSubTotal)}</Td>
                <Td className="text-amber-600">
                  {formatCurrency(r.releaseOrderNetPayable)}
                </Td>
                <Td className="text-emerald-600 font-medium">
                  {formatCurrency(r.profit)}
                </Td>
                {/* <Td>{r.marginPercent}%</Td> */}
              </tr>
            ))}
          </Table>
        )}
      </>
    );
  };

  const renderIncome = () => {
    if (!reportData) return null;
    const { summary, data } = reportData;
    const rows = data || [];
    return (
      <>
        <div className="grid grid-cols-5 gap-3 mb-5">
          <StatCard
            label="Revenue (Incl. GST)"
            value={formatCurrency(summary?.totalRevenue)}
          />
          <StatCard
            label="Cost (RO Base Amt, Excl. GST)"
            value={formatCurrency(summary?.totalCost)}
            tone="amber"
          />
          <StatCard
            label="Gross Profit (Excl. GST)"
            value={formatCurrency(summary?.totalGrossProfit)}
            tone="emerald"
          />
          <StatCard
            label="Collected"
            value={formatCurrency(summary?.totalCollected)}
            tone="blue"
          />
          <StatCard
            label="GST Collected"
            value={formatCurrency(summary?.totalGST)}
            tone="amber"
          />
        </div>
        {rows.length === 0 ? (
          <EmptyState message="No income data found for this period." />
        ) : (
          <Table
            headers={[
              "Month",
              "Invoices",
              "Taxable Value (Excl. GST)",
              "Cost (Excl. GST)",
              "Gross Profit",
              // "Margin",
              "Collected",
            ]}
          >
            {rows.map((r) => (
              <tr
                key={r.month}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">{r.month}</Td>
                <Td>{r.invoiceCount}</Td>
                <Td>{formatCurrency(r.taxableValue)}</Td>
                <Td className="text-amber-600">{formatCurrency(r.cost)}</Td>
                <Td className="text-emerald-600 font-medium">
                  {formatCurrency(r.grossProfit)}
                </Td>
                {/* <Td>{r.grossMarginPercent}%</Td> */}
                <Td className="text-blue-600">
                  {formatCurrency(r.collectedAmount)}
                </Td>
              </tr>
            ))}
          </Table>
        )}
      </>
    );
  };

  const renderOutstanding = () => {
    if (!reportData) return null;
    const { grandTotal, data } = reportData;
    const rows = data || [];
    const buckets = ["0-30", "31-60", "61-90", "91-180", "180+"];
    return (
      <>
        <div className="grid grid-cols-6 gap-3 mb-5">
          <StatCard
            label="Total Outstanding"
            value={formatCurrency(grandTotal?.totalOutstanding)}
            tone="red"
          />
          {buckets.map((b) => (
            <StatCard
              key={b}
              label={`${b} days`}
              value={formatCurrency(grandTotal?.buckets?.[b])}
              tone="amber"
            />
          ))}
        </div>
        {rows.length === 0 ? (
          <EmptyState message="No outstanding receivables found." />
        ) : (
          <Table
            headers={[
              "Client",
              "Total Outstanding",
              "0-30",
              "31-60",
              "61-90",
              "91-180",
              "180+",
            ]}
          >
            {rows.map((r) => (
              <tr
                key={r.clientId}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">{r.clientName}</Td>
                <Td className="text-red-500 font-medium">
                  {formatCurrency(r.totalOutstanding)}
                </Td>
                {buckets.map((b) => (
                  <Td key={b}>{formatCurrency(r.buckets?.[b])}</Td>
                ))}
              </tr>
            ))}
          </Table>
        )}
      </>
    );
  };

  const renderLedger = () => {
    if (!clientId) {
      return (
        <EmptyState message="Select a client above to view their ledger." />
      );
    }
    if (!reportData) return null;
    const { openingBalance, closingBalance, totals, ledger } = reportData;
    const rows = ledger || [];
    return (
      <>
        <div className="grid grid-cols-4 gap-3 mb-5">
          <StatCard
            label="Opening Balance"
            value={formatCurrency(openingBalance)}
          />
          <StatCard
            label="Bills Raised"
            value={formatCurrency(totals?.totalBillsRaised)}
            tone="amber"
          />
          <StatCard
            label="Payments & Credits"
            value={formatCurrency(totals?.totalPaymentsAndCreditsReceived)}
            tone="emerald"
          />
          <StatCard
            label="Closing Balance"
            value={formatCurrency(closingBalance)}
            tone="blue"
          />
        </div>
        {rows.length === 0 ? (
          <EmptyState message="No transactions found for this client in this period." />
        ) : (
          <Table
            headers={[
              "Date",
              "Type",
              "Reference",
              "Description",
              "Debit",
              "Credit",
              "Balance",
            ]}
          >
            {rows.map((t, i) => (
              <tr
                key={i}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td>{formatDate(t.date)}</Td>
                <Td className="capitalize">{t.type.replace("_", " ")}</Td>
                <Td>{t.reference || "—"}</Td>
                <Td className="whitespace-normal max-w-xs text-slate-600">
                  {t.description}
                </Td>
                <Td
                  className={
                    t.debit ? "text-red-500 font-medium" : "text-slate-300"
                  }
                >
                  {t.debit ? formatCurrency(t.debit) : "—"}
                </Td>
                <Td
                  className={
                    t.credit ? "text-emerald-600 font-medium" : "text-slate-300"
                  }
                >
                  {t.credit ? formatCurrency(t.credit) : "—"}
                </Td>
                <Td className="font-semibold text-slate-800">
                  {formatCurrency(t.balance)}
                </Td>
              </tr>
            ))}
          </Table>
        )}
      </>
    );
  };

  const renderGST = () => {
    if (!reportData) return null;
    const { summary, data } = reportData;
    const rows = data || [];
    const isInvoiceWise = gstGroupBy === "invoice";
    return (
      <>
        <div className="grid grid-cols-5 gap-3 mb-5">
          <StatCard
            label="Taxable Value"
            value={formatCurrency(summary?.totalTaxableValue)}
          />
          <StatCard
            label="CGST"
            value={formatCurrency(summary?.totalCGST)}
            tone="amber"
          />
          <StatCard
            label="SGST"
            value={formatCurrency(summary?.totalSGST)}
            tone="amber"
          />
          <StatCard
            label="Total Tax"
            value={formatCurrency(summary?.totalTax)}
            tone="emerald"
          />
          <StatCard
            label="Invoice Value"
            value={formatCurrency(summary?.totalInvoiceValue)}
            tone="blue"
          />
        </div>
        {rows.length === 0 ? (
          <EmptyState message="No GST data found for this period." />
        ) : isInvoiceWise ? (
          <Table
            headers={[
              "Invoice No.",
              "Date",
              "GSTIN",
              "Taxable Value",
              "CGST",
              "SGST",
              "Total Tax",
              "Invoice Value",
            ]}
          >
            {rows.map((r) => (
              <tr
                key={r.invoiceId}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">
                  {r.invoiceNumber}
                </Td>
                <Td>{formatDate(r.invoiceDate)}</Td>
                <Td>{r.clientGSTNumber || "—"}</Td>
                <Td>{formatCurrency(r.taxableValue)}</Td>
                <Td className="text-amber-600">
                  {formatCurrency(r.cgstAmount)}
                </Td>
                <Td className="text-amber-600">
                  {formatCurrency(r.sgstAmount)}
                </Td>
                <Td className="text-emerald-600 font-medium">
                  {formatCurrency(r.totalTax)}
                </Td>
                <Td>{formatCurrency(r.invoiceValue)}</Td>
              </tr>
            ))}
          </Table>
        ) : (
          <Table
            headers={[
              "Month",
              "Invoices",
              "Taxable Value",
              "CGST",
              "SGST",
              "Total Tax",
              "Invoice Value",
            ]}
          >
            {rows.map((r) => (
              <tr
                key={r.month}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">{r.month}</Td>
                <Td>{r.invoiceCount}</Td>
                <Td>{formatCurrency(r.taxableValue)}</Td>
                <Td className="text-amber-600">
                  {formatCurrency(r.cgstAmount)}
                </Td>
                <Td className="text-amber-600">
                  {formatCurrency(r.sgstAmount)}
                </Td>
                <Td className="text-emerald-600 font-medium">
                  {formatCurrency(r.totalTax)}
                </Td>
                <Td>{formatCurrency(r.invoiceValue)}</Td>
              </tr>
            ))}
          </Table>
        )}
      </>
    );
  };

  const renderCollection = () => {
    if (!reportData) return null;
    const { summary, data } = reportData;
    const rows = data || [];
    return (
      <>
        <div className="grid grid-cols-4 gap-3 mb-5">
          <StatCard
            label="Total Billed"
            value={formatCurrency(summary?.totalBilled)}
          />
          <StatCard
            label="Total Collected"
            value={formatCurrency(summary?.totalCollected)}
            tone="emerald"
          />
          <StatCard
            label="Total Pending"
            value={formatCurrency(summary?.totalPending)}
            tone="red"
          />
          <StatCard
            label="Collection Efficiency"
            value={`${summary?.collectionEfficiencyPercent ?? 0}%`}
            tone="blue"
          />
        </div>
        {rows.length === 0 ? (
          <EmptyState message="No collection data found for this period." />
        ) : (
          <Table
            headers={[
              "Month",
              "Billed",
              "Collected",
              "Pending",
              "Cumulative Pending",
            ]}
          >
            {rows.map((r) => (
              <tr
                key={r.month}
                className="border-b border-blue-50 hover:bg-blue-50/40 transition"
              >
                <Td className="font-semibold text-slate-800">{r.month}</Td>
                <Td>{formatCurrency(r.billedAmount)}</Td>
                <Td className="text-emerald-600 font-medium">
                  {formatCurrency(r.collectedAmount)}
                </Td>
                <Td className="text-red-500">
                  {formatCurrency(r.pendingAmount)}
                </Td>
                <Td>{formatCurrency(r.cumulativePending)}</Td>
              </tr>
            ))}
          </Table>
        )}
      </>
    );
  };

  const renderActiveTab = () => {
    if (loading) return <LoadingRows label="Crunching the numbers…" />;
    switch (activeTab) {
      case "profit":
        return renderProfit();
      case "income":
        return renderIncome();
      case "outstanding":
        return renderOutstanding();
      case "ledger":
        return renderLedger();
      case "gst":
        return renderGST();
      case "collection":
        return renderCollection();
      default:
        return null;
    }
  };

  const showClientFilter = true;
  const showDateFilter = activeTab !== "outstanding";

  return (
    <div className="min-h-screen bg-white text-slate-800">
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
              <RiLineChartLine className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-blue-800 tracking-tight">
                Finance Reports
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                Profit · Income · Receivables · GST
              </p>
            </div>
          </div>
          <button
            onClick={fetchReport}
            disabled={loading || (activeTab === "ledger" && !clientId)}
            title="Refresh"
            className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
          >
            <RiRefreshLine
              className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
            />
          </button>
        </div>

        {/* Tab strip */}
        <div className="w-full mx-auto px-6 flex gap-1 overflow-x-auto pb-2 pt-1">
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const active = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition ${
                  active
                    ? "bg-blue-600 text-white shadow-md shadow-blue-200"
                    : "text-blue-500 hover:bg-blue-50 border border-transparent"
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </header>

      <div className="w-full mx-auto px-6 pt-6 pb-10">
        {/* Filter bar */}
        <div className="bg-white border border-blue-100 rounded-2xl p-4 mb-5 shadow-sm flex items-end gap-4 flex-wrap">
          {showDateFilter && (
            <>
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                  From
                </label>
                <div className="relative">
                  <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                  To
                </label>
                <div className="relative">
                  <RiCalendarLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
                  />
                </div>
              </div>
            </>
          )}

          {showClientFilter && (
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Client{" "}
                {activeTab === "ledger" && (
                  <span className="text-red-400">*</span>
                )}
              </label>
              <div className="relative">
                <RiBankLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-300 pointer-events-none" />
                {clients.length > 0 ? (
                  <select
                    value={clientId}
                    onChange={(e) => setClientId(e.target.value)}
                    className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none min-w-[200px]"
                  >
                    <option value="">
                      {activeTab === "ledger"
                        ? "Select a client"
                        : "All clients"}
                    </option>
                    {clients.map((c) => (
                      <option key={c._id} value={c._id}>
                        {getClientName(c)}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    value={clientId}
                    onChange={(e) => setClientId(e.target.value)}
                    placeholder="Client ID"
                    className="bg-blue-50/60 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition min-w-[200px]"
                  />
                )}
              </div>
            </div>
          )}

          {activeTab === "profit" && (
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Group By
              </label>
              <select
                value={profitGroupBy}
                onChange={(e) => setProfitGroupBy(e.target.value)}
                className="bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none"
              >
                <option value="invoice">Invoice</option>
                <option value="month">Month</option>
                <option value="client">Client</option>
              </select>
            </div>
          )}

          {activeTab === "gst" && (
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Group By
              </label>
              <select
                value={gstGroupBy}
                onChange={(e) => setGstGroupBy(e.target.value)}
                className="bg-blue-50/60 border border-blue-200 rounded-lg px-3 py-2 text-sm text-slate-800 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition appearance-none"
              >
                <option value="month">Month</option>
                <option value="invoice">Invoice</option>
              </select>
            </div>
          )}

          <div className="flex gap-2 ml-auto">
            <button
              onClick={clearFilters}
              className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
            >
              <RiCloseLine className="w-4 h-4" /> Clear
            </button>
            <button
              onClick={fetchReport}
              disabled={activeTab === "ledger" && !clientId}
              className="flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white transition shadow-md shadow-blue-200 disabled:opacity-50"
            >
              Apply
            </button>
          </div>
        </div>

        {/* Report body */}
        <div className="bg-white border border-blue-100 rounded-2xl p-5 shadow-sm">
          {renderActiveTab()}
        </div>
      </div>

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
